import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'Adaptador Curricular Express',
  subtitle: 'Adapta los términos a tu país en 5 min',
  value: '$19',
  img: 'https://cdn.magicpatterns.com/uploads/diYmVycCpgL3C5PMpPJTb2/a27816a4-7763-49ef-ab0c-3536f4201684-mockup.webp'
}, {
  num: '2',
  title: 'Kit Anti-Improvisación',
  subtitle: 'Clases para días de lluvia o falta de material',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/qMaKZBaNjU7d5EBs4NCrsm/ca7e5ea5-149a-44c2-972a-e897fa6cc90a-mockup.webp'
}, {
  num: '3',
  title: 'Guía de Materiales Mínimos',
  subtitle: 'Cómo dar clases TOP con casi nada',
  value: '$27',
  img: 'https://cdn.magicpatterns.com/uploads/386bYxbRNZMToM4hK6FnpC/3a5d2acd-4d0f-4a78-bb75-54e15827b853-mockup.webp'
}, {
  num: '4',
  title: 'Manual de Control de Grupo',
  subtitle: 'Técnicas para un patio ordenado y seguro',
  value: '$20',
  img: 'https://cdn.magicpatterns.com/uploads/vhnLvDo5SXmBMUqf8N4M25/7404b489-ce4e-40d3-a4a5-2e70811cd07c-mockup.webp'
}, {
  num: '5',
  title: 'Guiones para Presentar tu Plan',
  subtitle: 'Habla como un pro ante directivos',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/pBHPtxq77HjDXhAJdzUZAX/13101a5b-4400-4c3f-b1cb-112c6e8f6191-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Valorados en{' '}
            <span className="line-through text-secondary" data-id="element-15">$140 USD</span> —
            Incluidos <span className="font-bold text-primary" data-id="element-16">GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-square bg-bg-main overflow-hidden p-8 sm:p-10" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bono {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm leading-snug mb-3 flex-1" data-id="element-25">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center gap-2 text-base" data-id="element-26">
                  <span className="text-secondary line-through font-medium" data-id="element-27">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-28">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}